module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-piemonte.svg?67a0828b721e28611c1eb199e7267d6e";